/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Stat } from './Stat';

class VerticalGroupingStat extends Stat {
    constructor() {
        super();
        this.baseUrl += '/verticalGroupingStat';
    }

    findVerticalGroupingStatList({
        certCatId,
        certExamType,
        verticalGroupingName,
        verticalGroupingSn,
        verticalGroupingStatus,
        statTime,
        insertTime,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let statTimeBegin = null;
        let statTimeEnd = null;
        if (statTime != null && statTime.length === 2) {
            [statTimeBegin, statTimeEnd] = statTime;
        }
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findVerticalGroupingStatList', {
            certCatId,
            certExamType,
            verticalGroupingName,
            verticalGroupingSn,
            verticalGroupingStatus,
            statTimeBegin,
            statTimeEnd,
            insertTimeBegin,
            insertTimeEnd,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }
}

export default new VerticalGroupingStat();
export { VerticalGroupingStat };
